import React, { useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Skel, fmt } from "./shared";

export default function UpdatesDue({ data, owner }) {
  const [sent, setSent] = useState({});
  if (!data) return <Skel rows={5} />;
  const rows = data.updates_due.filter(i => owner === "all" || i.owner_id === owner);
  const groups = Object.entries(rows.reduce((a, i) => { (a[i.owner_name || "No owner"] ||= []).push(i); return a; }, {}));
  const remind = async (i) => {
    try { await api.post(`/mel/indicators/${i.id}/remind`); setSent({ ...sent, [i.id]: true }); toast.success(`Reminder sent to ${i.owner_name}`); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not send reminder"); }
  };
  return (
    <Card data-testid="mon-updates"><CardContent className="p-0">
      <div className="px-4 py-3 border-b text-sm"><b>{rows.length}</b> update(s) for <span className="font-mono">{data.update_period}</span> · only indicators with a target and an owner are counted</div>
      {groups.length === 0 ? <div className="text-sm text-slate-500 p-6 text-center" data-testid="mon-updates-empty">Nothing due. All updates are in.</div> : groups.map(([name, items]) => (
        <div key={name} className="border-b last:border-0">
          <div className="px-4 py-2 bg-slate-50 text-xs font-semibold text-slate-600">{name} · {items.length}</div>
          {items.map(i => <div key={i.id} className="flex flex-wrap items-center gap-2 px-4 py-2 text-sm border-t border-slate-100" data-testid={`mon-due-${i.id}`}>
            <span className="flex-1 min-w-[200px] truncate">{i.name}</span>
            <span className="text-xs text-slate-500">Target {fmt(i.target)}</span>
            <span className={`text-xs ${i.state === "missing" ? "text-red-700" : "text-amber-700"}`}>{i.state === "missing" ? "Missing" : "Due"}</span>
            <a href={`/app/projects/${i.project_id}?tab=progress&period=${i.period}`}><Button size="sm" data-testid={`mon-due-enter-${i.id}`}>Enter update</Button></a>
            {data.can_remind && <Button size="sm" variant="outline" disabled={sent[i.id]} onClick={() => remind(i)} data-testid={`mon-due-remind-${i.id}`}>{sent[i.id] ? "Reminder sent" : "Send reminder"}</Button>}
          </div>)}
        </div>))}
    </CardContent></Card>
  );
}
